import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const InfoAddress = () => {
    return (
        <div className="info-address-wrapper xmt-8 xmt-lg-20">
            <div className="title xmb-2">
                <div className="title-box just-text title-box-blue">
                    <div className="title-bg">
                        <h2 className="text persian-number title-address">
                            جزییات آدرس ۱
                        </h2>
                    </div>
                    <div className="more edit-address-information">
                        <span className="icon-edit"><IconName name="create" className="icon"/></span>
                        <span className="text">ویرایش</span>
                    </div>
                </div>
            </div>
            <div className="inputs-wrapper">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="input-box">
                            <input type="text" className="input-information xmt-4 xmt-lg-6"
                                   value="" disabled="true"/>
                            <div className="default-value position-absolute">نام</div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-box">
                            <input type="text" className="input-information xmt-4 xmt-lg-6"
                                   value="" disabled="true"/>
                            <div className="default-value position-absolute">نام خانوادگی</div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-box position-relative">
                            <select
                                className="form-select select-information check-button-info xmt-4 xmt-lg-8"
                                aria-label="Default select example" disabled="true">
                                <option value="">استان</option>
                                <option value="21">اصفهان</option>
                                <option value="3">تهران</option>
                                <option value="4">فارس</option>
                            </select>
                            <IconName name="expand_more" className="more-icon icon position-absolute"/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="input-box position-relative">
                            <select
                                className="form-select select-information check-button-info xmt-4 xmt-lg-8"
                                aria-label="Default select example" disabled="true">
                                <option value="">شهر</option>
                                <option value="21">اصفهان</option>
                                <option value="3">تهران</option>
                                <option value="4">فارس</option>
                            </select>
                            <IconName name="expand_more" className="more-icon icon position-absolute"/>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="input-box">
                            <input type="text" className="user-address-information xmt-4 xmt-lg-6"
                                   value="کوی گلشهر، خیابان گلگشت شرقی، پلاک ۵۱، طبقه‌ی ۴. گلشهر، خیابان گلگشت شرقی" disabled="true"/>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="input-box">
                            <input type="number" className="input-information xmt-4 xmt-lg-6"
                                   value="51" disabled="true"/>
                            <div className="default-value position-absolute">کد پستی</div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="input-box">
                            <input type="number" className="input-information xmt-4 xmt-lg-6"
                                   value="35569884" disabled="true"/>
                            <div className="default-value position-absolute">شماره ثابت</div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="input-box">
                            <input type="number" className="input-information xmt-4 xmt-lg-6"
                                   value="09904456321" disabled="true"/>
                            <div className="default-value position-absolute">شماره موبایل‌</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoAddress;
